import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components';
import { useWeb3Context } from '@/contexts';
import { ChainId, getNetworkName } from '@/lib';
import classnames from 'classnames';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const RequestSwitchChain = ({ className, chainId, ...rest }) => {
    const t = useLocales();
    const { ethersProvider, providerChainId } = useWeb3Context();
    const cid = chainId || ChainId.Mainnet;
    return (_jsxs("div", { className: classnames(className, styles.container), ...rest, children: [_jsx("p", { className: styles.text, children: t('{network} is not supported yet', {
                    network: providerChainId ? getNetworkName(providerChainId) : '',
                }) }), _jsx(Button, { className: styles.button, onClick: () => {
                    if (ethersProvider?.provider) {
                        ethersProvider.provider.request({
                            method: 'wallet_switchEthereumChain',
                            params: [
                                {
                                    chainId: `0x${cid.toString(16)}`,
                                },
                            ],
                        });
                    }
                }, children: t('Switch to {network}', { network: getNetworkName(cid) }) })] }));
};
